import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { Typography, Grid, Card, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import { useNavigate ,useParams,useLocation} from "react-router-dom";
import { api } from "common";

function CustomerWallet(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const [selectedRow, setSelectedRow] = useState(null);
  const { fetchUsersOnce } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const {state} = useLocation();

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      const user = staticusers.filter(
        (user) => user.id === id.toString() && user.usertype === "customer"
      )[0];
      if (!user) {
        navigate("/404");
      }
      setData(user);
    } else {
      setData([]);
    }
  }, [staticusers, id, navigate]);

  const columns = [
    {
      title: t("requestDate"),
      field: "date",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
      render: (rowData) =>
        rowData.date ? moment(rowData.date).format("lll") : null,
    },
    {
      title: t("amount"),
      field: "amount",
      editable: "never",
      render: (rowData) =>
        rowData.amount
          ? data.swipe_symbol
            ? rowData.amount + " " + data.symbol
            : data.symbol + " " + rowData.amount
          : data.swipe_symbol
            ? "0 " + data.symbol
            : data.symbol + " 0",
    },
    {
      title: t("transaction_id"),
      field: "transaction_id",
      render: (rowData) =>
        rowData.transaction_id ? rowData.transaction_id : rowData.txRef,
    },
    {
      title: t("type"),
      field: "type",
      render: (rowData) => {
        const type = (rowData.type || '').toLowerCase();
        let bg = colors.THIRDCOLOR;
        if(type === 'credit' || type === 'credited') bg = colors.GREEN;
        else if(type === 'debit' || type === 'debited') bg = colors.RED;
        else if(type === 'withdraw') bg = colors.BLUE;
        else if(type === 'failed') bg = colors.ORANGE;
        return (
          <span
            style={{
              display:'inline-block',
              padding:'6px 14px',
              borderRadius: 20,
              backgroundColor: bg,
              color:'#fff',
              fontWeight: 600,
              minWidth: 90,
              width: '150px',
              textAlign:'center'
            }}
          >
            {rowData.type}
          </span>
        );
      },
    },
  ];
  return (
    <>
      <Card
        style={{
          borderRadius: "19px",
          backgroundColor: "#fff",
          marginTop: 5,
          marginBottom: 20,
          boxShadow: `0px 2px 5px ${colors.THIRDCOLOR}`,
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{ direction: isRTL === "rtl" ? "rtl" : "ltr", }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Card
              style={{
                borderRadius: "10px",
                backgroundColor: colors.WHITE,
                minHeight: 70,
                minWidth: 300,
                width: "80%",
                color: "white",
                display: "flex",
                boxShadow: `0px 2px 5px ${colors.THIRDCOLOR}`,
              }}
            >
              <Typography
                style={{
                  fontSize: 18,
                  backgroundColor: colors.MAIN_COLOR,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                {t("wallet_ballance")}
              </Typography>
              <Typography
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: colors.BLACK,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {props.data?.walletBalance
                  ? data.swipe_symbol
                    ? props.data.walletBalance + " " + data.symbol
                    : data.symbol + " " + props.data.walletBalance
                  : data.swipe_symbol
                    ? "0 " + data.symbol
                    : data.symbol + " 0"}
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div
              style={{
                backgroundColor: colors.WHITE,
                borderRadius: "8px",
              }}
            >
              <div
                dir={isRTL === "rtl" ? "rtl" : "ltr"}
              >
                <Button
                  variant="text"
                  onClick={() => {
                    navigate('/users/0', 
            { state: { pageNo: state?.pageNo }} )
                  }}
                  sx={{}}
                >
                  <Typography
                    style={{
                      textAlign: isRTL === "rtl" ? "right" : "left",
                      fontWeight: "bold",
                      color: colors.MAIN_COLOR,
                    }}
                  >
                    {`<<- ${t("go_back")}`}
                  </Typography>
                </Button>
              </div>
              <MaterialTable
                title={t("transaction_history_title")}
                columns={columns}
                style={{
                  direction: isRTL === "rtl" ? "rtl" : "ltr",
                  borderRadius: "8px",
                  boxShadow: `0px 2px 5px ${colors.THIRDCOLOR}`,
                }}
                data={props.wallet ? props.wallet.map(item => ({...item})) : []}
                onRowClick={(evt, selectedRow) =>
                  setSelectedRow(selectedRow.tableData.id)
                }
                options={{
                  pageSize: 10,
                  pageSizeOptions: [10, 15, 20],
                  exportButton: true,
                  rowStyle: rowData => ({
                    backgroundColor: (selectedRow === rowData.tableData.id) ? colors.THIRDCOLOR : colors.WHITE,
                  }),
                  editable: {
                    backgroundColor: colors.CARD_DETAIL,
                    fontSize: "0.8em",
                    fontWeight: "bold ",
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  },
                  headerStyle: {
                    backgroundColor: colors.SECONDARY,
                    color: colors.WHITE,
                    fontSize: "0.8em",
                    fontWeight: "bold ",
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    border: "1px solid rgba(224, 224, 224, 1)",
                    textAlign: "center",
                  },
                  cellStyle: {
                    border: "1px solid rgba(224, 224, 224, 1)",
                    padding: "20px",
                    textAlign: "center",
                  },
                }}
                localization={{
                  toolbar: {
                    searchPlaceholder: t("search"),
                    exportTitle: t("export"),
                  },
                  pagination: {
                    labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
                    firstTooltip: t("first_page_tooltip"),
                    previousTooltip: t("previous_page_tooltip"),
                    nextTooltip: t("next_page_tooltip"),
                    lastTooltip: t("last_page_tooltip"),
                  },
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}

export default CustomerWallet;
